import React from "react";
import bg from "./assets/images/bg.png";
import Map from "./components/map";
import MapSvg from "./components/svg-map";
import SvgMap2 from "./components/svg-map-2";

function App() {
    return (
        <>
            <SvgMap2 />
{/*<MapSvg />*/}
            {/*<div className="map__box">*/}
            {/*    <Map img={bg}/>*/}
            {/*</div>*/}
        </>
    );
}

export default App;
